import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import apiClient, { formatApiErrorDetail } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Check, Ship } from "lucide-react";
import { toast } from "sonner";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [status, setStatus] = useState("working"); // working | done | error
  const [orgName, setOrgName] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await apiClient.post("/org/accept", { token });
        setOrgName(data.org?.name || "the workspace");
        await checkAuth();
        setStatus("done");
        toast.success("You're in! 🎉");
        setTimeout(() => navigate("/dashboard"), 1400);
      } catch (err) {
        toast.error(formatApiErrorDetail(err.response?.data?.detail));
        setStatus("error");
      }
    })();
  }, [token, checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center wave-bg px-6">
      <div className="nb-card p-10 text-center max-w-md w-full">
        {status === "working" && (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-orange mx-auto mb-4" />
            <p className="font-display text-2xl font-700">Bringing you aboard…</p>
          </>
        )}
        {status === "done" && (
          <>
            <div className="h-14 w-14 bg-grass border-2 border-ink rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-nb-sm">
              <Check className="h-7 w-7 text-white" />
            </div>
            <p className="font-display text-2xl font-700">Welcome to {orgName}!</p>
            <p className="text-ink/60 font-600 mt-1">Taking you to the dashboard…</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="h-14 w-14 bg-orange border-2 border-ink rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-nb-sm">
              <Ship className="h-7 w-7 text-white" />
            </div>
            <p className="font-display text-2xl font-700">This invite has sailed</p>
            <p className="text-ink/60 font-600 mt-1 mb-5">It may have expired or already been used.</p>
            <button onClick={() => navigate("/dashboard")} className="nb-btn bg-orange text-white px-5 py-2.5 text-sm">Go to dashboard</button>
          </>
        )}
      </div>
    </div>
  );
}
